<footer class="cv-footer bg-light">
    <div class="container">
        <div class="row footer-link pb-3">
            <div class="col-lg-3 col-md-6 footer-columns">
                <h6 class="text-uppercase footer-headings">Industries</h6>
                <ul class="list-unstyled mb-0">
                    <li><a routerLink="/healthcare">Healthcare Survey</a></li>
                    <li><a routerLink="/education">Education Survey</a></li>
                    <li><a routerLink="/it-ites">IT & ITES Survey</a></li>
                    <li>
                        <a routerLink="/hotel-restaurants">Hotel & Restaurants Survey</a>
                    </li>
                    <li>
                        <a routerLink="/event-entertainment">Event & Entertainment Survey</a
            >
          </li>
          <li>
            <a routerLink="/retail-manufacturing"
              >Retail & Manufacturing Survey</a
            >
          </li>
        </ul>
      </div>
      <div class="col-lg-3 col-md-6 footer-columns">
        <h6 class="text-uppercase footer-headings">Quick Links</h6>
        <ul class="list-unstyled mb-0">
          <li>
            <a href="https://beta.cviewsurvey.com/signup" target="_blank"
              >Sign Up</a
            >
          </li>
          <li>
            <a href="http://beta.cviewsurvey.com/login" target="_blank"
              >Login</a
            >
          </li>
          <li><a routerLink="/features">Features</a></li>
                    <li><a routerLink="/templates">Templates</a></li>
                    <li><a routerLink="/how-it-works">How it Works</a></li>
                </ul>
            </div>
            <div class="col-lg-3 col-md-6 footer-columns">
                <h6 class="text-uppercase footer-headings">Company</h6>
                <ul class="list-unstyled mb-0">
                    <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    <li><a routerLink="/cookie-policy">Cookie Policy</a></li>
                    <li><a routerLink="/gdpr">GDPR</a></li>
                    <li><a routerLink="/blog">Blog</a></li>
                    <li><a routerLink="/faq">FAQ</a></li>
                </ul>
            </div>
            <div class="col-lg-3 col-md-6 footer-columns">
                <h6 class="text-uppercase footer-headings">Contact</h6>
                <ul class="list-unstyled mb-0">
                    <li>Phone: <a href="tel:+917314976629">(+91) 731 4976629</a></li>
                    <li>
                        Email:
                        <a href="mailto:contact@cviewsurvey.com">contact@cviewsurvey.com</a>
                    </li>
                </ul>
                <div class="d-flex mt-3">
                    <a href="https://play.google.com/store/apps/details?id=com.cviewsurvey.cviewsurvey" target="_blank" class="mr-2">
                        <img src="assets/play-store.svg" alt="CViewSurvey Play Store" />
                    </a>
                    <a href="https://www.apple.com/app-store/" target="_blank">
                        <img src="assets/apple-store.svg" alt="CViewSurvey App Store" />
                    </a>
                    <!-- <a (click)="downloadapk()">
                        <img src="assets/apple-store.svg" alt="CViewSurvey App Store">
                    </a> -->
                </div>
                <h6 class="mt-4 mb-2">CONNECT WITH US</h6>
                <ul class="list-unstyled">
                    <li class="d-inline-block mr-3">
                        <a href="https://www.linkedin.com/in/cviewsurvey-digitech-pvt-ltd-5767211bb/" target="_blank">
                            <img src="assets/linkedin.svg" alt="CViewSurvey linkedin" />
                        </a>
                    </li>
                    <li class="d-inline-block mr-3">
                        <a href="https://twitter.com/CviewSurvey" target="_blank">
                            <img class="img-fluid" src="assets/twitter.svg" alt="CViewSurvey Twitter" />
                        </a>
                    </li>
                    <li class="d-inline-block mr-3">
                        <a href="https://www.youtube.com/channel/UCxZX24QFhw4yB50A1__IcWA" target="_blank">
                            <img src="assets/youtube.svg" alt="CViewSurvey YouTube" />
                        </a>
                    </li>
                    <li class="d-inline-block mr-3">
                        <a href="https://www.facebook.com/profile.php?id=100057813342737" target="_blank">
                            <img class="img-fluid" src="assets/facebook.svg" alt="CViewSurvey Facebook" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="footer-copyright border-top py-3">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <ul class="list-unstyled mb-0">
                        <li class="mr-2 d-none">
                            <a routerLink="/terms-of-services">Terms of Service</a>
                        </li>
                        <li class="d-inline-block mr-2">
                            <a routerLink="/security-policy">Security Policy</a>
                        </li>
                        <li class="d-none">
                            <a routerLink="/unsubscribes">Unsubscribes</a>
                        </li>
                        <li class="d-inline-block">
                            <a routerLink="/nps-survey">NPS<sup>&reg;</sup> Survey</a>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-5 text-right">
                    <ul class="list-unstyled mb-0">
                        <li>
                            Copyright©2021, <a href="javascript:void(0)">cviewsurvey.com</a> | All Rights Reserved
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <a href="javascript:void(0);" id="scroll" title="Scroll to Top" style="display: none">Top<span></span
  ></a>
    <div id="cookiePolicy" class="alert alert-secondary alert-dismissable fade show" *ngIf="isCookieaccepted != 'true'">
        <!-- <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button> -->
        <div class="row">
            <div class="
          col-lg-2
          d-lg-flex
          justify-content-center
          align-items-center
          d-none
        ">
                <img src="assets/cookies.svg" class="img-fluid" alt="cookies Policy" />
            </div>
            <div class="col-lg-8">
                <h6 class="d-block mb-3 text-white">What do we use cookies for?</h6>
                <p class="mb-0 text-white">
                    We use cookies and similar technologies to recognize our repeat visits and preferences, as well as to measure the effectiveness of campaigns and analyze traffic. To learn more about cookies, including how to disable them, view our
                    <a routerLink="/cookie-policy">Cookie Policy</a>. By clicking I Accept on this banner. or using our site. You consent to the use of cookies unless you have disable
                </p>
            </div>
            <div class="col-lg-2 d-flex justify-content-center align-items-center">
                <button class="btn btn-success mt-3 mt-lg-0 text-center" data-dismiss="alert" (click)="acceptCookiePolicy()" aria-label="Close">
          I Accept
        </button>
            </div>
        </div>
    </div>
</footer>

<!-- book a demo modal-->
<div class="modal" id="callBack">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="font-weight-bold modal-title">Book a Demo</h5>
                <button type="button" class="close" data-dismiss="modal">×</button>
            </div>
            <!-- Modal body -->
            <div class="modal-body p-0">
                <div class="row">
                    <div class="col-lg-12">
                        <!--   <form id="contact-form" method="post" action="contact.php" role="form"> -->
                        <form [formGroup]="contact_form" (ngSubmit)="submitForm()">
                            <div class="messages"></div>
                            <div class="controls">
                                <div class="scheduleBox bg-gray border-bottom py-3 px-4">
                                    <div *ngIf="
                      bookmsg ==
                      'Your Demo has booked , Check your email for further updates...!!!!'
                    " class="alert alert-success" id="book_msg">
                                        {{ bookmsg }}
                                    </div>
                                    <!-- <div class="alert alert-danger"  >Your Demo has booked , Check your email for further updates...!!!!</div> -->
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="form_name">Name<span class="text-danger">*</span></label
                        >
                        <input
                          id="form_name"
                          formControlName="name"
                          type="text"
                          name="name"
                          class="form-control"
                          placeholder="Name"
                          [ngClass]="{
                            'is-invalid': submitted && f1.email.errors
                          }"
                        />
                        <div
                          *ngIf="submitted && f1.name.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f1.name.errors.required">
                            Name is required*
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="form_email"
                          >Email<span class="text-danger">*</span></label
                        >
                        <input
                          id="form_email"
                          type="email"
                          name="email"
                          formControlName="email"
                          class="form-control"
                          placeholder="Email"
                          [ngClass]="{
                            'is-invalid': submitted && f1.email.errors
                          }"
                        />
                        <div
                          *ngIf="submitted && f1.email.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f1.email.errors.required">
                            Valid Email Address is required*
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="form_need">Country code</label>
                                                <select name="countryCode" id="c_code" class="form-control" formControlName="country_code" placeholder="Enter country code">
                          <option data-countryCode="IN" value="91" selected>
                            India (+91)
                          </option>
                          <optgroup label="Other countries">
                            <option data-countryCode="DZ" value="213">
                              Algeria (+213)
                            </option>
                            <option data-countryCode="AD" value="376">
                              Andorra (+376)
                            </option>
                            <option data-countryCode="AO" value="244">
                              Angola (+244)
                            </option>
                            <option data-countryCode="AI" value="1264">
                              Anguilla (+1264)
                            </option>
                            <option data-countryCode="AG" value="1268">
                              Antigua &amp; Barbuda (+1268)
                            </option>
                            <option data-countryCode="AR" value="54">
                              Argentina (+54)
                            </option>
                            <option data-countryCode="AM" value="374">
                              Armenia (+374)
                            </option>
                            <option data-countryCode="AW" value="297">
                              Aruba (+297)
                            </option>
                            <option data-countryCode="AU" value="61">
                              Australia (+61)
                            </option>
                            <option data-countryCode="AT" value="43">
                              Austria (+43)
                            </option>
                            <option data-countryCode="AZ" value="994">
                              Azerbaijan (+994)
                            </option>
                            <option data-countryCode="BS" value="1242">
                              Bahamas (+1242)
                            </option>
                            <option data-countryCode="BH" value="973">
                              Bahrain (+973)
                            </option>
                            <option data-countryCode="BD" value="880">
                              Bangladesh (+880)
                            </option>
                            <option data-countryCode="BB" value="1246">
                              Barbados (+1246)
                            </option>
                            <option data-countryCode="BY" value="375">
                              Belarus (+375)
                            </option>
                            <option data-countryCode="BE" value="32">
                              Belgium (+32)
                            </option>
                            <option data-countryCode="BZ" value="501">
                              Belize (+501)
                            </option>
                            <option data-countryCode="BJ" value="229">
                              Benin (+229)
                            </option>
                            <option data-countryCode="BM" value="1441">
                              Bermuda (+1441)
                            </option>
                            <option data-countryCode="BT" value="975">
                              Bhutan (+975)
                            </option>
                            <option data-countryCode="BO" value="591">
                              Bolivia (+591)
                            </option>
                            <option data-countryCode="BA" value="387">
                              Bosnia Herzegovina (+387)
                            </option>
                            <option data-countryCode="BW" value="267">
                              Botswana (+267)
                            </option>
                            <option data-countryCode="BR" value="55">
                              Brazil (+55)
                            </option>
                            <option data-countryCode="BN" value="673">
                              Brunei (+673)
                            </option>
                            <option data-countryCode="BG" value="359">
                              Bulgaria (+359)
                            </option>
                            <option data-countryCode="BF" value="226">
                              Burkina Faso (+226)
                            </option>
                            <option data-countryCode="BI" value="257">
                              Burundi (+257)
                            </option>
                            <option data-countryCode="KH" value="855">
                              Cambodia (+855)
                            </option>
                            <option data-countryCode="CM" value="237">
                              Cameroon (+237)
                            </option>
                            <option data-countryCode="CA" value="1">
                              Canada (+1)
                            </option>
                            <option data-countryCode="CV" value="238">
                              Cape Verde Islands (+238)
                            </option>
                            <option data-countryCode="KY" value="1345">
                              Cayman Islands (+1345)
                            </option>
                            <option data-countryCode="CF" value="236">
                              Central African Republic (+236)
                            </option>
                            <option data-countryCode="CL" value="56">
                              Chile (+56)
                            </option>
                            <option data-countryCode="CN" value="86">
                              China (+86)
                            </option>
                            <option data-countryCode="CO" value="57">
                              Colombia (+57)
                            </option>
                            <option data-countryCode="KM" value="269">
                              Comoros (+269)
                            </option>
                            <option data-countryCode="CG" value="242">
                              Congo (+242)
                            </option>
                            <option data-countryCode="CK" value="682">
                              Cook Islands (+682)
                            </option>
                            <option data-countryCode="CR" value="506">
                              Costa Rica (+506)
                            </option>
                            <option data-countryCode="HR" value="385">
                              Croatia (+385)
                            </option>
                            <option data-countryCode="CU" value="53">
                              Cuba (+53)
                            </option>
                            <option data-countryCode="CY" value="90392">
                              Cyprus North (+90392)
                            </option>
                            <option data-countryCode="CY" value="357">
                              Cyprus South (+357)
                            </option>
                            <option data-countryCode="CZ" value="42">
                              Czech Republic (+42)
                            </option>
                            <option data-countryCode="DK" value="45">
                              Denmark (+45)
                            </option>
                            <option data-countryCode="DJ" value="253">
                              Djibouti (+253)
                            </option>
                            <option data-countryCode="DM" value="1809">
                              Dominica (+1809)
                            </option>
                            <option data-countryCode="DO" value="1809">
                              Dominican Republic (+1809)
                            </option>
                            <option data-countryCode="EC" value="593">
                              Ecuador (+593)
                            </option>
                            <option data-countryCode="EG" value="20">
                              Egypt (+20)
                            </option>
                            <option data-countryCode="SV" value="503">
                              El Salvador (+503)
                            </option>
                            <option data-countryCode="GQ" value="240">
                              Equatorial Guinea (+240)
                            </option>
                            <option data-countryCode="ER" value="291">
                              Eritrea (+291)
                            </option>
                            <option data-countryCode="EE" value="372">
                              Estonia (+372)
                            </option>
                            <option data-countryCode="ET" value="251">
                              Ethiopia (+251)
                            </option>
                            <option data-countryCode="FK" value="500">
                              Falkland Islands (+500)
                            </option>
                            <option data-countryCode="FO" value="298">
                              Faroe Islands (+298)
                            </option>
                            <option data-countryCode="FJ" value="679">
                              Fiji (+679)
                            </option>
                            <option data-countryCode="FI" value="358">
                              Finland (+358)
                            </option>
                            <option data-countryCode="FR" value="33">
                              France (+33)
                            </option>
                            <option data-countryCode="GF" value="594">
                              French Guiana (+594)
                            </option>
                            <option data-countryCode="PF" value="689">
                              French Polynesia (+689)
                            </option>
                            <option data-countryCode="GA" value="241">
                              Gabon (+241)
                            </option>
                            <option data-countryCode="GM" value="220">
                              Gambia (+220)
                            </option>
                            <option data-countryCode="GE" value="7880">
                              Georgia (+7880)
                            </option>
                            <option data-countryCode="DE" value="49">
                              Germany (+49)
                            </option>
                            <option data-countryCode="GH" value="233">
                              Ghana (+233)
                            </option>
                            <option data-countryCode="GI" value="350">
                              Gibraltar (+350)
                            </option>
                            <option data-countryCode="GR" value="30">
                              Greece (+30)
                            </option>
                            <option data-countryCode="GL" value="299">
                              Greenland (+299)
                            </option>
                            <option data-countryCode="GD" value="1473">
                              Grenada (+1473)
                            </option>
                            <option data-countryCode="GP" value="590">
                              Guadeloupe (+590)
                            </option>
                            <option data-countryCode="GU" value="671">
                              Guam (+671)
                            </option>
                            <option data-countryCode="GT" value="502">
                              Guatemala (+502)
                            </option>
                            <option data-countryCode="GN" value="224">
                              Guinea (+224)
                            </option>
                            <option data-countryCode="GW" value="245">
                              Guinea - Bissau (+245)
                            </option>
                            <option data-countryCode="GY" value="592">
                              Guyana (+592)
                            </option>
                            <option data-countryCode="HT" value="509">
                              Haiti (+509)
                            </option>
                            <option data-countryCode="HN" value="504">
                              Honduras (+504)
                            </option>
                            <option data-countryCode="HK" value="852">
                              Hong Kong (+852)
                            </option>
                            <option data-countryCode="HU" value="36">
                              Hungary (+36)
                            </option>
                            <option data-countryCode="IS" value="354">
                              Iceland (+354)
                            </option>
                            <option data-countryCode="IN" value="91" selected>
                              India (+91)
                            </option>
                            <option data-countryCode="ID" value="62">
                              Indonesia (+62)
                            </option>
                            <option data-countryCode="IR" value="98">
                              Iran (+98)
                            </option>
                            <option data-countryCode="IQ" value="964">
                              Iraq (+964)
                            </option>
                            <option data-countryCode="IE" value="353">
                              Ireland (+353)
                            </option>
                            <option data-countryCode="IL" value="972">
                              Israel (+972)
                            </option>
                            <option data-countryCode="IT" value="39">
                              Italy (+39)
                            </option>
                            <option data-countryCode="JM" value="1876">
                              Jamaica (+1876)
                            </option>
                            <option data-countryCode="JP" value="81">
                              Japan (+81)
                            </option>
                            <option data-countryCode="JO" value="962">
                              Jordan (+962)
                            </option>
                            <option data-countryCode="KZ" value="7">
                              Kazakhstan (+7)
                            </option>
                            <option data-countryCode="KE" value="254">
                              Kenya (+254)
                            </option>
                            <option data-countryCode="KI" value="686">
                              Kiribati (+686)
                            </option>
                            <option data-countryCode="KP" value="850">
                              Korea North (+850)
                            </option>
                            <option data-countryCode="KR" value="82">
                              Korea South (+82)
                            </option>
                            <option data-countryCode="KW" value="965">
                              Kuwait (+965)
                            </option>
                            <option data-countryCode="KG" value="996">
                              Kyrgyzstan (+996)
                            </option>
                            <option data-countryCode="LA" value="856">
                              Laos (+856)
                            </option>
                            <option data-countryCode="LV" value="371">
                              Latvia (+371)
                            </option>
                            <option data-countryCode="LB" value="961">
                              Lebanon (+961)
                            </option>
                            <option data-countryCode="LS" value="266">
                              Lesotho (+266)
                            </option>
                            <option data-countryCode="LR" value="231">
                              Liberia (+231)
                            </option>
                            <option data-countryCode="LY" value="218">
                              Libya (+218)
                            </option>
                            <option data-countryCode="LI" value="417">
                              Liechtenstein (+417)
                            </option>
                            <option data-countryCode="LT" value="370">
                              Lithuania (+370)
                            </option>
                            <option data-countryCode="LU" value="352">
                              Luxembourg (+352)
                            </option>
                            <option data-countryCode="MO" value="853">
                              Macao (+853)
                            </option>
                            <option data-countryCode="MK" value="389">
                              Macedonia (+389)
                            </option>
                            <option data-countryCode="MG" value="261">
                              Madagascar (+261)
                            </option>
                            <option data-countryCode="MW" value="265">
                              Malawi (+265)
                            </option>
                            <option data-countryCode="MY" value="60">
                              Malaysia (+60)
                            </option>
                            <option data-countryCode="MV" value="960">
                              Maldives (+960)
                            </option>
                            <option data-countryCode="ML" value="223">
                              Mali (+223)
                            </option>
                            <option data-countryCode="MT" value="356">
                              Malta (+356)
                            </option>
                            <option data-countryCode="MH" value="692">
                              Marshall Islands (+692)
                            </option>
                            <option data-countryCode="MQ" value="596">
                              Martinique (+596)
                            </option>
                            <option data-countryCode="MR" value="222">
                              Mauritania (+222)
                            </option>
                            <option data-countryCode="YT" value="269">
                              Mayotte (+269)
                            </option>
                            <option data-countryCode="MX" value="52">
                              Mexico (+52)
                            </option>
                            <option data-countryCode="FM" value="691">
                              Micronesia (+691)
                            </option>
                            <option data-countryCode="MD" value="373">
                              Moldova (+373)
                            </option>
                            <option data-countryCode="MC" value="377">
                              Monaco (+377)
                            </option>
                            <option data-countryCode="MN" value="976">
                              Mongolia (+976)
                            </option>
                            <option data-countryCode="MS" value="1664">
                              Montserrat (+1664)
                            </option>
                            <option data-countryCode="MA" value="212">
                              Morocco (+212)
                            </option>
                            <option data-countryCode="MZ" value="258">
                              Mozambique (+258)
                            </option>
                            <option data-countryCode="MN" value="95">
                              Myanmar (+95)
                            </option>
                            <option data-countryCode="NA" value="264">
                              Namibia (+264)
                            </option>
                            <option data-countryCode="NR" value="674">
                              Nauru (+674)
                            </option>
                            <option data-countryCode="NP" value="977">
                              Nepal (+977)
                            </option>
                            <option data-countryCode="NL" value="31">
                              Netherlands (+31)
                            </option>
                            <option data-countryCode="NC" value="687">
                              New Caledonia (+687)
                            </option>
                            <option data-countryCode="NZ" value="64">
                              New Zealand (+64)
                            </option>
                            <option data-countryCode="NI" value="505">
                              Nicaragua (+505)
                            </option>
                            <option data-countryCode="NE" value="227">
                              Niger (+227)
                            </option>
                            <option data-countryCode="NG" value="234">
                              Nigeria (+234)
                            </option>
                            <option data-countryCode="NU" value="683">
                              Niue (+683)
                            </option>
                            <option data-countryCode="NF" value="672">
                              Norfolk Islands (+672)
                            </option>
                            <option data-countryCode="NP" value="670">
                              Northern Marianas (+670)
                            </option>
                            <option data-countryCode="NO" value="47">
                              Norway (+47)
                            </option>
                            <option data-countryCode="OM" value="968">
                              Oman (+968)
                            </option>
                            <option data-countryCode="PW" value="680">
                              Palau (+680)
                            </option>
                            <option data-countryCode="PA" value="507">
                              Panama (+507)
                            </option>
                            <option data-countryCode="PG" value="675">
                              Papua New Guinea (+675)
                            </option>
                            <option data-countryCode="PY" value="595">
                              Paraguay (+595)
                            </option>
                            <option data-countryCode="PE" value="51">
                              Peru (+51)
                            </option>
                            <option data-countryCode="PH" value="63">
                              Philippines (+63)
                            </option>
                            <option data-countryCode="PL" value="48">
                              Poland (+48)
                            </option>
                            <option data-countryCode="PT" value="351">
                              Portugal (+351)
                            </option>
                            <option data-countryCode="PR" value="1787">
                              Puerto Rico (+1787)
                            </option>
                            <option data-countryCode="QA" value="974">
                              Qatar (+974)
                            </option>
                            <option data-countryCode="RE" value="262">
                              Reunion (+262)
                            </option>
                            <option data-countryCode="RO" value="40">
                              Romania (+40)
                            </option>
                            <option data-countryCode="RU" value="7">
                              Russia (+7)
                            </option>
                            <option data-countryCode="RW" value="250">
                              Rwanda (+250)
                            </option>
                            <option data-countryCode="SM" value="378">
                              San Marino (+378)
                            </option>
                            <option data-countryCode="ST" value="239">
                              Sao Tome &amp; Principe (+239)
                            </option>
                            <option data-countryCode="SA" value="966">
                              Saudi Arabia (+966)
                            </option>
                            <option data-countryCode="SN" value="221">
                              Senegal (+221)
                            </option>
                            <option data-countryCode="CS" value="381">
                              Serbia (+381)
                            </option>
                            <option data-countryCode="SC" value="248">
                              Seychelles (+248)
                            </option>
                            <option data-countryCode="SL" value="232">
                              Sierra Leone (+232)
                            </option>
                            <option data-countryCode="SG" value="65">
                              Singapore (+65)
                            </option>
                            <option data-countryCode="SK" value="421">
                              Slovak Republic (+421)
                            </option>
                            <option data-countryCode="SI" value="386">
                              Slovenia (+386)
                            </option>
                            <option data-countryCode="SB" value="677">
                              Solomon Islands (+677)
                            </option>
                            <option data-countryCode="SO" value="252">
                              Somalia (+252)
                            </option>
                            <option data-countryCode="ZA" value="27">
                              South Africa (+27)
                            </option>
                            <option data-countryCode="ES" value="34">
                              Spain (+34)
                            </option>
                            <option data-countryCode="LK" value="94">
                              Sri Lanka (+94)
                            </option>
                            <option data-countryCode="SH" value="290">
                              St. Helena (+290)
                            </option>
                            <option data-countryCode="KN" value="1869">
                              St. Kitts (+1869)
                            </option>
                            <option data-countryCode="SC" value="1758">
                              St. Lucia (+1758)
                            </option>
                            <option data-countryCode="SD" value="249">
                              Sudan (+249)
                            </option>
                            <option data-countryCode="SR" value="597">
                              Suriname (+597)
                            </option>
                            <option data-countryCode="SZ" value="268">
                              Swaziland (+268)
                            </option>
                            <option data-countryCode="SE" value="46">
                              Sweden (+46)
                            </option>
                            <option data-countryCode="CH" value="41">
                              Switzerland (+41)
                            </option>
                            <option data-countryCode="SI" value="963">
                              Syria (+963)
                            </option>
                            <option data-countryCode="TW" value="886">
                              Taiwan (+886)
                            </option>
                            <option data-countryCode="TJ" value="7">
                              Tajikstan (+7)
                            </option>
                            <option data-countryCode="TH" value="66">
                              Thailand (+66)
                            </option>
                            <option data-countryCode="TG" value="228">
                              Togo (+228)
                            </option>
                            <option data-countryCode="TO" value="676">
                              Tonga (+676)
                            </option>
                            <option data-countryCode="TT" value="1868">
                              Trinidad &amp; Tobago (+1868)
                            </option>
                            <option data-countryCode="TN" value="216">
                              Tunisia (+216)
                            </option>
                            <option data-countryCode="TR" value="90">
                              Turkey (+90)
                            </option>
                            <option data-countryCode="TM" value="7">
                              Turkmenistan (+7)
                            </option>
                            <option data-countryCode="TM" value="993">
                              Turkmenistan (+993)
                            </option>
                            <option data-countryCode="TC" value="1649">
                              Turks &amp; Caicos Islands (+1649)
                            </option>
                            <option data-countryCode="TV" value="688">
                              Tuvalu (+688)
                            </option>
                            <option data-countryCode="UG" value="256">
                              Uganda (+256)
                            </option>
                            <option data-countryCode="GB" value="44">
                              UK (+44)
                            </option>
                            <option data-countryCode="UA" value="380">
                              Ukraine (+380)
                            </option>
                            <option data-countryCode="AE" value="971">
                              United Arab Emirates (+971)
                            </option>
                            <option data-countryCode="UY" value="598">
                              Uruguay (+598)
                            </option>
                            <option data-countryCode="US" value="1">
                              USA (+1)
                            </option>
                            <option data-countryCode="UZ" value="7">
                              Uzbekistan (+7)
                            </option>
                            <option data-countryCode="VU" value="678">
                              Vanuatu (+678)
                            </option>
                            <option data-countryCode="VA" value="379">
                              Vatican City (+379)
                            </option>
                            <option data-countryCode="VE" value="58">
                              Venezuela (+58)
                            </option>
                            <option data-countryCode="VN" value="84">
                              Vietnam (+84)
                            </option>
                            <option data-countryCode="VG" value="84">
                              Virgin Islands - British (+1284)
                            </option>
                            <option data-countryCode="VI" value="84">
                              Virgin Islands - US (+1340)
                            </option>
                            <option data-countryCode="WF" value="681">
                              Wallis &amp; Futuna (+681)
                            </option>
                            <option data-countryCode="YE" value="969">
                              Yemen (North)(+969)
                            </option>
                            <option data-countryCode="YE" value="967">
                              Yemen (South)(+967)
                            </option>
                            <option data-countryCode="ZM" value="260">
                              Zambia (+260)
                            </option>
                            <option data-countryCode="ZW" value="263">
                              Zimbabwe (+263)
                            </option>
                          </optgroup>
                        </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="form_need">Mobile No.</label>
                                                <input id="form_email" formControlName="mobile" type="text" name="mobile" class="form-control" placeholder="Mobile" maxlength="10" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <label for="form_message">Please Select Date<span class="text-danger"
                          >*</span
                        ></label
                      >
                      <div class="form-group">
                        <input
                          autocomplete="off"
                          name="date"
                          placement="top"
                          type="text"
                          placeholder="Select date"
                          class="form-control"
                          bsDatepicker
                          formControlName="date"
                          [bsConfig]="{ isAnimated: true }"
                          [bsConfig]="{
                            showWeekNumbers: false,
                            customTodayClass: 'custom-today-class'
                          }"
                          [minDate]="minDate"
                          [maxDate]="maxDate"
                          formControlName="date"
                          [ngClass]="{
                            'is-invalid': submitted && f1.date.errors
                          }"
                        />
                        <div
                          *ngIf="submitted && f1.date.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f1.date.errors.required">
                            Date is required*
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label for="form_message"
                        >Please Select time<span class="text-danger"
                          >*</span
                        ></label
                      >
                      <div class="form-group mb-0">
                        <select
                          class="form-control"
                          name=""
                          id=""
                          formControlName="time"
                          [ngClass]="{
                            'is-invalid': submitted && f1.time.errors
                          }"
                        >
                          <option value="">Select Timeslot</option>
                          <option value="10-11 AM">10-11 AM</option>
                          <option value="11-12 PM">11-12 PM</option>
                          <option value="12-01 PM">12-01 PM</option>
                          <option value="01-02 PM">01-02 PM</option>
                          <option value="02-03 PM">02-03 PM</option>
                          <option value="03-04 PM">03-04 PM</option>
                          <option value="04-05 PM">04-05 PM</option>
                          <option value="05-06 PM">05-06 PM</option>
                          <option value="06-07 PM">06-07 PM</option>
                        </select>
                        <div
                          *ngIf="submitted && f1.time.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f1.time.errors.required">
                            Time is required*
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <label for="form_message"
                        >What is the primary purpose for using CViewSurvey?<span
                          class="text-danger"
                          >*</span
                        ></label
                      >
                      <div class="form-group">
                        <select
                          class="form-control"
                          name="purpose"
                          id=""
                          formControlName="purpose"
                          [ngClass]="{
                            'is-invalid': submitted && f1.purpose.errors
                          }"
                        >
                          <option value="">Select Purpose</option>
                          <option value="Customer Experience">
                            Customer Experience
                          </option>
                          <option value="Field Survey & Market Research">
                            Field Survey & Market Research
                          </option>
                          <option value="Employee Experience">
                            Employee Experience
                          </option>
                          <option value="NPS Survey">NPS Survey</option>
                          <option value="Other">Other</option>
                        </select>
                        <div
                          *ngIf="submitted && f1.purpose.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f1.purpose.errors.required">
                            Purpose is required*
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="custom-control custom-checkbox mr-sm-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="bd_privacy"
                        />
                        <label class="custom-control-label" for="bd_privacy"
                          >By requesting demo, you agree to our
                          <a
                            (click)="privacyLoad()"
                            routerLink="/privacy-policy"
                            >Privacy Policy</a
                          >.</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="infoBox py-3 px-4">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <!-- <input class="d-none" type="reset"> -->
                      <input
                        type="submit"
                        class="btn btn-success btn-send text-uppercase"
                        value="Send message"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- book a demo modal-->

<!-- get in touch modal-->
<div class="modal" id="getintouch">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="font-weight-bold modal-title">Get in Touch</h5>
        <button type="button" class="close" data-dismiss="modal">×</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body p-0">
        <!--   <form id="contact-form" method="post" action="contact.php" role="form"> -->
        <form [formGroup]="getInTouchForm" (ngSubmit)="submitgetInTouchForm()">
          <div class="messages"></div>
          <div class="controls">
            <div class="scheduleBox bg-gray border-bottom py-3 px-4">
              <div
                *ngIf="getintouchmsg"
                class="alert alert-success"
                id="book_msg"
              >
                {{ getintouchmsg }}
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="form_name"
                      >Name<span class="text-danger">*</span></label
                    >
                    <input
                      id="form_name"
                      formControlName="name"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder="Name"
                      [ngClass]="{
                        'is-invalid': GITsubmitted && f.name.errors
                      }"
                    />
                    <div
                      *ngIf="GITsubmitted && f.name.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.name.errors.required" style="color: red">
                        Name is required*
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="form_email"
                      >Email<span class="text-danger">*</span></label
                    >
                    <input
                      id="form_email"
                      type="email"
                      name="email"
                      formControlName="email"
                      class="form-control"
                      placeholder="Email"
                      required="required"
                      [ngClass]="{
                        'is-invalid': GITsubmitted && f.email.errors
                      }"
                    />
                    <div
                      *ngIf="GITsubmitted && f.email.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.email.errors.required" style="color: red">
                        Valid Email Address is required*
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="form_need">Mobile No.</label>
                                            <input id="form_email" type="email" name="email" formControlName="mobile" class="form-control" placeholder="Mobile" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="infoBox py-3 px-4">
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <input type="submit" class="btn btn-success btn-send text-uppercase" value="Send message" />
                                    </div>
                                </div>
                            </div>
                    </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- get in touch modal-->